import { render, staticRenderFns } from "./channel-posts-table.vue?vue&type=template&id=c2f8a664&scoped=true&"
import script from "./channel-posts-table.vue?vue&type=script&lang=js&"
export * from "./channel-posts-table.vue?vue&type=script&lang=js&"
import style0 from "./channel-posts-table.vue?vue&type=style&index=0&id=c2f8a664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f8a664",
  null
  
)

export default component.exports